<template>
  <div>
    <div class="hero">
      <div class="title ml-5 mt-5" style="z-index: +3; color: white"><b style="font-size: 40px;">Cookies Policy</b></div>
      <v-img src="@/assets/blue-fierce.jpg" height="150" />
    </div>
    <v-container>   
      <div v-for="Document in document" :key="Document.id" >
        <div v-if="Document.name === 'Cookies' ">
          <span v-html="Document.description"></span>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
	import {db} from '@/firebase';
	export default {
		name : "terms",
		props: {
      msg: String
    },
    data: () => ({
      document: [],
      nav_title: 'Cookies Policy',
    }),
    firestore() {
      return {
        document: db.collection('document')
      }
    }
	}
</script>

<style scoped>
  .title {
    position: absolute;
    top: 100px;
  }
</style>